export const PRODUCT_CATEGORY_CODES = {
    PR0003: 'PRODUCT_CATEGORY_ALREADY_EXISTS',
};
